class EquipmentCommon {
    public static readonly ROOT_FILE = 'EquipmentInfo.xml';
    public static readonly REGEX_EQUIPMENT_ID = /<Equipment id="(.*)">/;
    public static readonly REGEX_DB3_FILE = /^.*\.(db3)$/;
    public static readonly REGEX_DB3_SVLOG_FILE = /^SvLog_.+\.db3$/;
    public static readonly LOG_FOLDER = 'Log';
    public static readonly ROOT_FILE_JSON = 'equipment-info.json';
    public static readonly REGEX_CSV_FILE = /^.*\.(csv)$/;
    public static readonly LOG_FOLDER_CSV = 'aimscs_{yyyyMMdd_HHmmss}';
    public static readonly REGEX_LOG_FOLDER_CSV = /^aimscs_\d{8}_\d{6}$/;
    public static readonly EQUIPMENT_ID_KEY = 'equipment_id';
    public static readonly PREFIX_LOG_FOLDER_CSV = 'tb_';
    public static readonly REGEX_CSV_FILE_PART = /^(tb_svlog_\d+)_([1-9]\d*)(\.csv)$/;
    public static readonly SUFFIX_CSV_FILE_PART = '_0_part_';
}

export default EquipmentCommon;
